import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { FlatList } from 'native-base';
import React from 'react';

interface StructuredOperationContentData {
  label: string;
  value: React.JSX.Element | string;
}

interface StructuredOperationContentHorizontalListProps {
  data: StructuredOperationContentData[];
}

export const StructuredOperationContentHorizontalList: React.FC<
  StructuredOperationContentHorizontalListProps
> = ({ data }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const numColumns = isMobile ? 2 : 3;

  return (
    <FlatList
      key={numColumns}
      testID={'structured-operation-content-horizontal-list'}
      data={data}
      contentContainerStyle={{ rowGap: 16 }}
      showsVerticalScrollIndicator={false}
      keyExtractor={(item) => item.label}
      numColumns={numColumns}
      renderItem={({ item }) => {
        const valueIsText = typeof item.value === 'string';

        const valueItemText = (
          <Text color={'neutral.black'} variant="regular" fontSize={Typography['fontsize.md']}>
            {item.value}
          </Text>
        );

        const valueItemComponent = item.value;

        const itemValue = valueIsText ? valueItemText : valueItemComponent;

        return (
          <VStack flex={1} space={Spacing['inset.quarck']}>
            <Text color={'neutral.black'} variant="semibold" fontSize={Typography['fontsize.xs']}>
              {item.label}
            </Text>
            {itemValue}
          </VStack>
        );
      }}
    />
  );
};
